import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  EamData,
  NibudData,
  Offer,
  OfferRequestParams,
  ContractApplicationParams,
  ContractApplicationResult,
} from '../../../types/orchestrator';
import { API_URL, API_URL_OPTIONS } from '../../../../../shared/config/constants';
import { AddressQueryFnParameters } from '../../../../../shared/containers/AddressSelection/types';
import { gjtom3 } from '../../../helpers/gasCalculation';

// Define a service using a base URL and expected endpoints
export const heatApi = createApi({
  reducerPath: 'heatApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    postContractApplication: builder.mutation<ContractApplicationResult, ContractApplicationParams>({
      query: (params) => ({
        url: '/v1/heat/contract/aanvraag',
        ...API_URL_OPTIONS,
        method: 'POST',
        body: params,
        validateStatus: (_, { Results }: ContractApplicationResult) => {
          return Results[0]?.Success === 'Y';
        },
      }),
    }),
    getEamData: builder.query<EamData[], AddressQueryFnParameters>({
      query: ({ postal_code, housenumber }) => ({
        url: `/v1/heat/aansluitingen?postcode=${postal_code}&huisnummer=${housenumber}`,
        ...API_URL_OPTIONS,
      }),
      transformResponse: (response: EamData[]) => response.map((item) => {
        return {
          ...item,
          // The API can return the SjvTot in the GetEamdData response as a decimal number.
          // Through when we send the SjvTot to the API in the postContractApplication request, it expects a whole number.
          // So we rewrite the SjvTot to a whole number here on the highest level, preventing any issues.
          SjvTot: String(Math.round(Number(item.SjvTot?.replace(',', '.')))),
        };
      }),
    }),
    getOffer: builder.query<Offer, OfferRequestParams>({
      query: ({ ean, sjvGJ }) => ({
        url: `/v1/heat/offerte?eanCode=${ean}&standaardJaarVerbruik=${sjvGJ!}`,
        ...API_URL_OPTIONS,
      }),
    }),
    getNibudData: builder.query<NibudData[], null>({
      query: () => ({
        url: '/v1/heat/nibud/verbruiksgegevens/warmte',
        ...API_URL_OPTIONS,
      }),
    }),
  }),
});

export const {
  useGetEamDataQuery,
  useGetOfferQuery,
  useGetNibudDataQuery,
  usePostContractApplicationMutation,
} = heatApi;
